var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/pages/remote-instance-page.tsx";
import React from 'react';
import LinkFooter from 'soapbox/features/ui/components/link-footer';
import BundleContainer from 'soapbox/features/ui/containers/bundle-container';
import { PromoPanel, InstanceInfoPanel, InstanceModerationPanel } from 'soapbox/features/ui/util/async-components';
import { useAppSelector, useOwnAccount } from 'soapbox/hooks';
import { federationRestrictionsDisclosed } from 'soapbox/utils/state';
import { Layout } from '../components/ui';

/** Page for viewing a remote instance timeline. */
const RemoteInstancePage = _ref => {
  let {
    children,
    params
  } = _ref;
  const host = params === null || params === void 0 ? void 0 : params.instance;
  const account = useOwnAccount();
  const disclosed = useAppSelector(federationRestrictionsDisclosed);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(Layout.Aside, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: PromoPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "promo-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 25
    }
  })), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: InstanceInfoPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    host: host,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 25
    }
  })), (disclosed || (account === null || account === void 0 ? void 0 : account.admin)) && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: InstanceModerationPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    host: host,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(LinkFooter, {
    key: "link-footer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  })));
};

export default RemoteInstancePage;